import { createContext, useContext } from 'react';

/**
 * Carries the DOM node of a placeholder slot inside DashboardShell's own
 * top bar (to the left of Log out). Lets a page rendered as DashboardShell's
 * children -- which may need route-aware content (e.g. Lead Quality Score's
 * breadcrumb, which reads useParams() from its own nested <Routes>, not
 * available to DashboardShell itself) -- portal content into that single
 * shared bar instead of rendering a second bar of its own underneath it.
 */
const ShellHeaderExtraContext = createContext(null);
export const ShellHeaderExtraProvider = ShellHeaderExtraContext.Provider;

export function useShellHeaderExtra() {
  return useContext(ShellHeaderExtraContext);
}
